import React from 'react';

const HeaderLoading = ({text}) => {
    return (
        <div className="text-center text-white">
            <span className="fa-stack fa-2x">
                <i className="fas fa-spinner fa-spin fa-stack-2x"></i>
                <i className="fas fa-award fa-xs"></i>
            </span>
            <p className="mt-3">
                {text ? text : "Loading ..." }
            </p>
        </div>
    );
}

export default HeaderLoading;